import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { Moment } from 'moment'
import CellBase from '@/components/weekly-schedule/calendar/CellBase.vue'
import { Item } from '@/components/weekly-schedule/utils'
import EventJobDetailsCard from '@/components/weekly-schedule/EventJobDetailsCard.vue'
import EventCellJobProgressBar from '@/components/weekly-schedule/EventCellJobProgressBar.vue'
import EventCellJobDetails from '@/components/weekly-schedule/EventCellJobDetails.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobCell',
  props: {
    job: null,
    weekStart: null
  },
  emits: ["click:job", "select:job", "context:job", "drag:job"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'click:job', job: Item): void
  (event: 'select:job', job: Item, mouseEvent: MouseEvent): void
  (event: 'context:job', job: Item, mouseEvent: MouseEvent): void
  (event: 'drag:job', job: Item, dragEvent: DragEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  job: Item
  weekStart: Moment
}





const cellClassNames = computed(() => {
  return {
    'is-crossed-out': props.job.isCompleted || props.job.isCancelled,
    'new-priority': props.job.priority.name === 'New',
    selected: props.job.isSelected,
  }
})
const colour = computed<string | undefined>(
  () => props.job.division?.hexCode ?? undefined
)
const onClick = () => emit('click:job', props.job)
const onCtrlClick = (mouseEvent: MouseEvent) =>
  // const isMac = /Mac/.test(navigator.userAgent)
  emit('select:job', props.job, mouseEvent)
const onContextMenu = (mouseEvent: MouseEvent) =>
  emit('context:job', props.job, mouseEvent)
const onDrag = (dragEvent: DragEvent) => emit('drag:job', props.job, dragEvent)

return { __sfc: true,props, emit, cellClassNames, colour, onClick, onCtrlClick, onContextMenu, onDrag, CellBase, EventJobDetailsCard, EventCellJobProgressBar, EventCellJobDetails }
}

})